import { SECONDS_IN_HOUR } from '@cast/constants';
import { DateRangeFilter } from '@cast/shared-date-ui';
import { bytesToUnit, convertUnit } from '@cast/utils';

import { DateRangeUnsupportedBanner } from '../_components/DateRangeUnsupportedBanner';
import { ResourceBreakdownChart } from '../_components/ResourceBreakdownChart';
import { WidgetLayout } from '../../../_components/ui/WidgetLayout';
import { useInventoryWorkloadsTimeRangeSelection } from '../../../_hooks/useInventoryWorkloadsTimeRangeSelection';

import { useNetworkTrafficBreakdownChartData } from './_hooks/useNetworkTrafficBreakdownChartData';
import { NETWORK_TRAFFIC_BREAKDOWN_CHART_DATA_SETTINGS } from './_constants';
import { NetworkTrafficBreakdownChartDataKey } from './_types';

const DATA_KEYS: NetworkTrafficBreakdownChartDataKey[] = [
  'intraAz',
  'crossAz',
  'internet',
  'crossRegion',
  'cloudApi',
];

const formatTrafficYAxis = (value: number): string => {
  const bytes = convertUnit(value, 'GiB', 'Bytes');
  const [amount, unit] = bytesToUnit(bytes, 0);

  return `${amount} ${unit}`;
};

export const NetworkTrafficBreakdownChart = () => {
  const { timeZone, getRange, preset } =
    useInventoryWorkloadsTimeRangeSelection();
  const { from, to } = getRange();

  const { data, isLoading, isFetching, error, refetch, stepSeconds } =
    useNetworkTrafficBreakdownChartData();

  const timeUnit = stepSeconds === SECONDS_IN_HOUR ? 'hour' : 'day';

  if (preset === DateRangeFilter.LastHour) {
    return (
      <WidgetLayout
        title="Traffic breakdown"
        testId="network-traffic-breakdown-chart"
      >
        <DateRangeUnsupportedBanner testId="network-traffic-breakdown-chart-unsupported-range" />
      </WidgetLayout>
    );
  }

  return (
    <ResourceBreakdownChart
      title="Traffic breakdown"
      testId="network-traffic-breakdown-chart"
      data={data}
      isLoading={isLoading}
      isFetching={isFetching}
      error={error}
      refetch={refetch}
      dataKeys={DATA_KEYS}
      chartDataSettings={NETWORK_TRAFFIC_BREAKDOWN_CHART_DATA_SETTINGS}
      unit="GiB"
      timeZone={timeZone}
      dateRange={{ from, to }}
      timeUnit={timeUnit}
      step={1}
      filler={() => ({})}
      yAxisFormatter={formatTrafficYAxis}
    />
  );
};
